export default __webpack_public_path__ + "static/media/WNo.8-3.89981eb3.jpg";